import { useCallback, useMemo, useState } from 'react';
import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';

const COMPASS_COMPONENTS_NAMESPACE = 'compass-components';

type ControllerResult = [{ hasBeenDismissed: boolean }, { dismiss: () => void; reset: () => void }];

export function useTouchPointDismissed(): ControllerResult {
	const accountId = useAccountId();
	const storageKey = `table-crossflow-dismissed-${accountId}`;
	const storage = useMemo(() => createLocalStorageProvider(COMPASS_COMPONENTS_NAMESPACE), []);
	const [hasBeenDismissed, setHasBeenDismissed] = useState<boolean>(storage.get(storageKey));

	const dismiss = useCallback(() => {
		setHasBeenDismissed(true);
		storage.set(storageKey, true);
	}, [setHasBeenDismissed, storage, storageKey]);

	const reset = useCallback(() => {
		setHasBeenDismissed(false);
		storage.remove(storageKey);
	}, [setHasBeenDismissed, storage, storageKey]);

	return [
		{
			hasBeenDismissed,
		},
		{
			dismiss,
			reset,
		},
	];
}
